/* New mega menu (desktop) + new menu drawer (mobile).
   Loaded only when the header section setting "use_new_mega_menu" is on. */

window.Blundstone = window.Blundstone || {};

(() => {
  if (customElements.get('blundstone-mega-menu')) return;

  class BlundstoneMegaMenu extends HTMLElement {
    connectedCallback() {
      this.detailsItems = Array.from(this.querySelectorAll('details.custom-mega-menu__details'));
      this.hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.openTimer = null;
      this.closeTimer = null;

      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.closeAll();
      };
      document.addEventListener('click', this.onDocumentClick);

      this.addEventListener('keyup', (event) => {
        if (event.code !== 'Escape') return;
        const openItem = this.querySelector('details[open]');
        if (!openItem) return;
        this.closeAll();
        openItem.querySelector('summary').focus();
      });

      this.addEventListener('focusout', (event) => {
        // Focus moving between our own summaries blanks activeElement for a frame.
        if (this.contains(event.relatedTarget)) return;
        requestAnimationFrame(() => {
          if (!this.contains(document.activeElement)) this.closeAll();
        });
      });

      // Close when the sticky header hides itself on scroll down.
      const sectionHeader = this.closest('.section-header');
      if (sectionHeader) {
        new MutationObserver(() => {
          if (sectionHeader.classList.contains('shopify-section-header-hidden')) this.closeAll();
        }).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
      }

      this.detailsItems.forEach((details) => {
        const summary = details.querySelector('summary');

        summary.addEventListener('click', (event) => {
          event.preventDefault();
          // Where hover governs the panel, ignore pointer clicks; keyboard reports detail 0.
          if (this.hoverEnabled && event.detail !== 0) return;
          if (details.hasAttribute('open')) {
            this.close(details);
          } else {
            this.open(details);
          }
        });

        if (this.hoverEnabled) {
          const item = details.closest('li');
          item.addEventListener('mouseenter', () => {
            clearTimeout(this.closeTimer);
            clearTimeout(this.openTimer);
            this.openTimer = setTimeout(() => this.open(details), 100);
          });
          item.addEventListener('mouseleave', () => {
            clearTimeout(this.openTimer);
            this.closeTimer = setTimeout(() => this.close(details), 150);
          });
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    open(details) {
      this.detailsItems.forEach((other) => {
        if (other !== details) this.close(other);
      });
      details.setAttribute('open', '');
      details.querySelector('summary').setAttribute('aria-expanded', 'true');
    }

    close(details) {
      details.removeAttribute('open');
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.detailsItems.forEach((details) => this.close(details));
    }
  }

  customElements.define('blundstone-mega-menu', BlundstoneMegaMenu);
  window.Blundstone.MegaMenu = BlundstoneMegaMenu;

  class BlundstoneMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.drawer = this.querySelector('.custom-drawer');
      this.activePanel = null;
      this.activeButton = null;

      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.details.hasAttribute('open')) {
          this.closeDrawer();
        } else {
          this.openDrawer();
        }
      });

      this.querySelectorAll('[data-panel-target]').forEach((button) => {
        button.addEventListener('click', () => this.openPanel(button));
      });

      this.querySelectorAll('[data-panel-back]').forEach((button) => {
        button.addEventListener('click', () => this.closePanel());
      });

      this.addEventListener('keyup', (event) => {
        if (event.code !== 'Escape') return;
        if (this.activePanel) {
          this.closePanel();
        } else if (this.details.hasAttribute('open')) {
          this.closeDrawer();
          this.summary.focus();
        }
      });

      this.onResize = () => {
        if (this.details.hasAttribute('open')) this.setDrawerHeight();
      };
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('overflow-hidden-tablet');
    }

    setDrawerHeight() {
      const top = this.drawer.getBoundingClientRect().top;
      this.drawer.style.height = `${window.innerHeight - Math.max(top, 0)}px`;
    }

    openDrawer() {
      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
      this.setDrawerHeight();
      requestAnimationFrame(() => this.details.classList.add('menu-opening'));
      document.body.classList.add('overflow-hidden-tablet');
    }

    closeDrawer() {
      this.details.classList.remove('menu-opening');
      this.details.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');
      this.closePanel();
      document.body.classList.remove('overflow-hidden-tablet');
    }

    openPanel(button) {
      const panel = this.querySelector(`[id="${button.dataset.panelTarget}"]`);
      if (!panel) return;
      this.closePanel();
      panel.classList.add('is-open');
      panel.scrollTop = 0;
      button.setAttribute('aria-expanded', 'true');
      this.activePanel = panel;
      this.activeButton = button;
    }

    closePanel() {
      if (!this.activePanel) return;
      this.activePanel.classList.remove('is-open');
      this.activeButton.setAttribute('aria-expanded', 'false');
      this.activePanel = null;
      this.activeButton = null;
    }
  }

  customElements.define('blundstone-menu-drawer', BlundstoneMenuDrawer);
  window.Blundstone.MenuDrawer = BlundstoneMenuDrawer;
})();
